const QUESTIONS_SELECTOR = '[data-trustpilot-product-questions]';
const LOADER_SRC = 'https://widget.trustpilot.com/product-questions/loader.js';

const SCRIPT_ATTRS = [
  ['businessUnitId', 'data-business-unit-id'],
  ['sku', 'data-sku'],
  ['name', 'data-name'],
  ['styleWidth', 'data-style-width'],
  ['styleHeight', 'data-style-height'],
  ['locale', 'data-locale'],
  ['buttonColor', 'data-button-color'],
  ['buttonTextColor', 'data-button-text-color'],
];

const isInsideClosedAccordion = (el) => {
  const details = el?.closest('details');
  return Boolean(details && !details.open);
};

const loadProductQuestions = (container) => {
  if (!container || container.dataset.trustpilotQuestionsLoaded === 'true') return;
  // Don't hit Trustpilot while FAQs accordion is collapsed (404 spam + wasted requests)
  if (isInsideClosedAccordion(container)) return;

  const script = document.createElement('script');
  script.src = LOADER_SRC;
  script.async = true;

  SCRIPT_ATTRS.forEach(([datasetKey, attr]) => {
    const value = container.dataset[datasetKey];
    if (value) {
      script.setAttribute(attr, value);
    }
  });

  container.appendChild(script);
  container.dataset.trustpilotQuestionsLoaded = 'true';
};

const loadQuestionsInRoot = (root = document) => {
  root.querySelectorAll(QUESTIONS_SELECTOR).forEach(loadProductQuestions);
};

let accordionReloadBound = false;

const bindFaqsAccordionLoad = () => {
  if (accordionReloadBound) return;
  accordionReloadBound = true;

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (details.tagName !== 'DETAILS' || !details.open) return;

      details.querySelectorAll(QUESTIONS_SELECTOR).forEach(loadProductQuestions);
    },
    true
  );
};

const initTrustpilotProductQuestions = (root = document) => {
  loadQuestionsInRoot(root);
  bindFaqsAccordionLoad();
};

export default initTrustpilotProductQuestions;
